<template>
    <button @click.prevent="buttonClick" class="migrol-form__button" :class="[cssclass, {'migrol-form__button--loading': isWaitingForAjax}]" :disabled="disabledCondition || isWaitingForAjax">
        <span class="migrol-form__button-label">{{label}}</span>
        <span class="migrol-form__button-loading"><i class="fas fa-redo"></i></span>
    </button>
</template>

<script>
    export default {
        props: {
            isWaitingForAjax: {
                type: Boolean,
                default: false,
                required: true
            },
            label: {
                type: String,
                required: false,
                default: ''
            },
            cssclass: {
                type: String,
                default: null,
                required: false
            },
            disabledCondition: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        methods: {
            buttonClick() {
                this.$emit('buttonClick')
            }
        }
    };
</script>